/** Meta Pixel ID bootstrapped in CookieConsentBanner after consent. */
export const META_PIXEL_IDS = ['528565525249930'] as const;

export type MetaPixelId = (typeof META_PIXEL_IDS)[number];
